module.exports = __webpack_public_path__ + "img/cpqy.4803b6b2.png";